var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buildingOwner)?_c('div',[_c('span',{class:_vm.mandateCurrentTantiemes > 0 ? 'text-dark font-weight-bold' : 'text-muted font-weight-light'},[_vm._v(" "+_vm._s(_vm.buildingOwner.name)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }